import { getDictionary } from 'lib/apiClient';
import useSWR, { Fetcher } from 'swr';
import { Dictionary } from '.';

function createCacheKey(language: string): string {
	return `dictionary-${language}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDictionaryApi(language: string, fallbackData: Dictionary) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const fetcher: Fetcher<Dictionary> = async () => {
		return getDictionary(language);
	};

	return useSWR(createCacheKey(language), fetcher, { fallbackData });

	//extra space to pass sonar tests https://sonarcloud.io/api/ce/task?id=AZIgsYCrPmRU0dvYoWL9
}
